import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 border-t-2 border-slate-700 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Brand */}
          <div>
            {/* Logo styled like navbar */}
            <div
              className="inline-block px-4 py-2 rounded-[18px] border-2 border-[#0b3f59] font-black uppercase tracking-wide text-sm mb-4"
              style={{
                background: '#0F172A',
                boxShadow: 'inset 0 2px 0 rgba(255,255,255,0.2), 3px 3px 0 rgba(0,0,0,0.7)',
              }}
            >
              <span
                style={{
                  color: '#2FB4E9',
                  textShadow: '0 2px 0 rgba(0,0,0,0.5)',
                }}
              >
                PORK
              </span>
              <span
                style={{
                  color: '#FF6FAF',
                  textShadow: '0 2px 0 rgba(0,0,0,0.5)',
                  marginLeft: '4px',
                }}
              >
                COPS
              </span>
            </div>

            <p className="text-slate-400 text-sm">
              Sporc Matters. An original comic series.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-[#2FB4E9] uppercase font-bold tracking-widest text-sm mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-slate-400 hover:text-white transition-colors">
                  Support Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-[#2FB4E9] uppercase font-bold tracking-widest text-sm mb-4">
              Legal
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-slate-700 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Pork Cops. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
